var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import { ELSIcon } from 'components/common';
import { LIST_BOX_INDEX } from 'components/common/list-box/ListBox';
var ListBoxModal = /** @class */ (function (_super) {
    __extends(ListBoxModal, _super);
    function ListBoxModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (option, listIndex) {
            if (listIndex === LIST_BOX_INDEX.PARENT) {
                _this.setState({
                    selectedOption: option,
                    selectedDependedOption: option.dependedOptions && option.dependedOptions.length ? option.dependedOptions[0] : null
                });
            }
            if (listIndex === LIST_BOX_INDEX.DEPENDENT) {
                _this.setState({
                    selectedDependedOption: option
                });
            }
        };
        _this.closeModal = function () {
            var _a = _this.props, value = _a.value, dependedValue = _a.dependedValue;
            var _b = _this.state, selectedOption = _b.selectedOption, selectedDependedOption = _b.selectedDependedOption;
            if (value !== selectedOption.value) {
                _this.props.changeHandler(selectedOption, 0);
            }
            if (_this.props.hasDependent && dependedValue !== selectedDependedOption.value) {
                _this.props.changeHandler(selectedDependedOption, 1);
            }
            _this.props.closeHandler();
        };
        _this.getDependedOptions = function () {
            var selectedOption = _this.state.selectedOption;
            return selectedOption ? selectedOption.dependedOptions || [] : [];
        };
        _this.renderItem = function (option, selected, listIndex) {
            var handler = function () {
                _this.onChange(option, listIndex);
            };
            return (<li role="option" aria-selected={selected} className={classNames('c-had-list-box-modal__item u-cursor-pointer', { 'c-had-list-box-modal__item--selected': selected })} key={uuidv4()} onClick={handler} onKeyPress={handler}>
        {option.icon && <ELSIcon customClass="u-els-margin-right-1o2" name={option.icon} size="3o4"/>}
        {option.name}
      </li>);
        };
        var _a = _this.props, options = _a.options, value = _a.value, dependedValue = _a.dependedValue;
        var selectedOption = options.find(function (option) { return option.value === value; });
        var selectedDependedOption = (selectedOption.dependedOptions || []).find(function (option) { return option.value === dependedValue; });
        _this.state = {
            selectedOption: selectedOption,
            selectedDependedOption: selectedDependedOption
        };
        document.documentElement.classList.add('c-list-box-modal--opened');
        return _this;
    }
    ListBoxModal.prototype.componentWillUnmount = function () {
        document.documentElement.classList.remove('c-list-box-modal--opened');
    };
    ListBoxModal.prototype.render = function () {
        var _this = this;
        var _a = this.props, options = _a.options, header = _a.header, headerIcon = _a.headerIcon, hasDependent = _a.hasDependent, headerTitleClass = _a.headerTitleClass;
        var _b = this.state, selectedOption = _b.selectedOption, selectedDependedOption = _b.selectedDependedOption;
        return (<div className={classNames('c-had-list-box-modal')}>
        <header className="c-had-list-box-modal__header">
          <span className={classNames('c-had-list-box-modal__header__title', headerTitleClass)}>
            <ELSIcon customClass="u-els-margin-right-1o2" name={headerIcon} size="1x"/>
            <span>{header}</span>
          </span>
          <ELSIcon customClass="u-cursor-pointer c-had-list-box-modal__header__close" name="close" size="1x" onClick={this.closeModal}/>
        </header>

        <div className="c-had-list-box-modal__body">
          <ul>{options.map(function (option) { return _this.renderItem(option, option.value === selectedOption.value, LIST_BOX_INDEX.PARENT); })}</ul>
        </div>

        {hasDependent && (<footer className="c-had-list-box-modal__footer">
            {this.getDependedOptions().map(function (option) { return _this.renderItem(option, option.value === selectedDependedOption.value, LIST_BOX_INDEX.DEPENDENT); })}
          </footer>)}
      </div>);
    };
    return ListBoxModal;
}(Component));
export default ListBoxModal;
